import React from "react";
import {
  AbstractIntentSelector,
  AbstractSubmissionFields,
  PaperLockedNotice,
} from "../abstract/AbstractSubmissionModule";

export const InlineAbstractSubmissionStep = ({
  abstractStepNumber,
  shouldSkipInlineAbstractStep,
  hasPaperSubmitted,
  wantsToSubmitAbstract,
  onChooseAbstract,
  onContinueAsDelegate,
  isPaperLocked,
  abstractConfig,
  maxAbstractChars,
  maxFileSizeMb,
  paperTitle,
  onPaperTitleChange,
  selectedTrack,
  tracks,
  onSelectedTrackChange,
  presentationMode,
  onPresentationModeChange,
  submissionMethod,
  onSubmissionMethodChange,
  abstractText,
  onAbstractTextChange,
  paperFileUploaded,
  paperFile,
  paperFileName,
  paperFileError,
  onPaperFileChange,
  onPaperFileErrorChange,
  onUploadedFileDelete,
  onSelectedFileRemove,
  coAuthors,
  coAuthorErrors,
  onAddCoAuthor,
  onUpdateCoAuthor,
  onRemoveCoAuthor,
  conferenceId,
  submittedPapers,
}) => {
  if (shouldSkipInlineAbstractStep(abstractStepNumber)) {
    return null;
  }

  return (
    <>
      <AbstractIntentSelector
        hasPaperSubmitted={hasPaperSubmitted}
        wantsToSubmitAbstract={wantsToSubmitAbstract}
        onChooseAbstract={onChooseAbstract}
        onContinueAsDelegate={onContinueAsDelegate}
      />

      {wantsToSubmitAbstract === true && (
        <>
          {isPaperLocked && <PaperLockedNotice />}

          <AbstractSubmissionFields
            abstractConfig={abstractConfig}
            maxAbstractChars={maxAbstractChars}
            maxFileSizeMb={maxFileSizeMb}
            paperTitle={paperTitle}
            onPaperTitleChange={onPaperTitleChange}
            selectedTrack={selectedTrack}
            tracks={tracks}
            onSelectedTrackChange={onSelectedTrackChange}
            presentationMode={presentationMode}
            onPresentationModeChange={onPresentationModeChange}
            submissionMethod={submissionMethod}
            onSubmissionMethodChange={onSubmissionMethodChange}
            abstractText={abstractText}
            onAbstractTextChange={onAbstractTextChange}
            paperFileUploaded={paperFileUploaded}
            paperFile={paperFile}
            paperFileName={paperFileName}
            paperFileError={paperFileError}
            onPaperFileChange={onPaperFileChange}
            onPaperFileErrorChange={onPaperFileErrorChange}
            onUploadedFileDelete={onUploadedFileDelete}
            onSelectedFileRemove={onSelectedFileRemove}
            coAuthors={coAuthors}
            coAuthorErrors={coAuthorErrors}
            onAddCoAuthor={onAddCoAuthor}
            onUpdateCoAuthor={onUpdateCoAuthor}
            onRemoveCoAuthor={onRemoveCoAuthor}
            isPaperLocked={isPaperLocked}
            submittedPapers={submittedPapers}
            beforeTrackSelect={(() => {
              console.log("Tracks dropdown state:", {
                tracks,
                tracksLength: tracks?.length || 0,
                selectedTrack,
                conferenceId,
              });
              return null;
            })()}
            beforeCoAuthors={(() => {
              console.log("Checking co-authors display:", {
                abstractConfig,
                coAuthors: abstractConfig?.coAuthors,
                type: typeof abstractConfig?.coAuthors,
                shouldShow: abstractConfig?.coAuthors === true,
              });
              return null;
            })()}
          />
        </>
      )}
    </>
  );
};
